import './messages.css'
import Message from '../../components/messages/Message'

const Messages = () =>{
    return(
        <div className="mecosse">
            <Message /> 
        </div>
    )
}
 

export default Messages